import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Robot_Video2 } from '../../../../../utils/EN/Modals/aiArtists';

const ModalVideoRobot2 = () => {
  return (
    <>
      <ModalVideo
        id="robot-video-2"
        dataText={Robot_Video2}
        videoSrc="https://www.youtube.com/embed/9OzS_lCtiPs?si=WOzWt2qj7ZLJhyk0"
        videoTitle="KUTER_STUDIO_AI_ROBOT_VIDEO_2"
      />
    </>
  );
};

export default ModalVideoRobot2;
